import { z } from 'zod';

export enum AppUserType {
    Admin = 'Admin',
    Dealer = 'Dealer',
    Partner = 'Partner',
    Customer = 'Customer',
}

export const AppUserTypeSchema = z.nativeEnum(AppUserType);
